import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { MUNICIPALITY_OPTIONS, REGION_OPTIONS } from '../utils/courseLocationData';

export default function CourseDialog({
  open,
  courseForm,
  saving,
  onClose,
  onSubmit,
  onFieldChange,
}) {
  const isEditing = Boolean(courseForm?.courseID);

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditing ? 'Muokkaa rataa' : 'Lisää uusi rata'}</DialogTitle>
      <DialogContent>
        <div className="mt-2 grid gap-4">
          <TextField
            label="Nimi"
            variant="filled"
            value={courseForm?.name ?? ''}
            onChange={onFieldChange('name')}
            fullWidth
            required
          />

          <TextField
            label="Paikkakunta"
            variant="filled"
            value={courseForm?.municipality ?? ''}
            onChange={onFieldChange('municipality')}
            fullWidth
            required
            select
          >
            <MenuItem value="" disabled>Valitse paikkakunta</MenuItem>
            {MUNICIPALITY_OPTIONS.map((municipality) => (
              <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
            ))}
          </TextField>

          <FormControl variant="filled" fullWidth required>
            <InputLabel id="course-region-label">Maakunta</InputLabel>
            <Select
              labelId="course-region-label"
              value={courseForm?.region ?? ''}
              onChange={onFieldChange('region')}
            >
              <MenuItem value="" disabled>Valitse maakunta</MenuItem>
              {REGION_OPTIONS.map((region) => (
                <MenuItem key={region} value={region}>{region}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="secondary" disabled={saving}>Peruuta</Button>
        <Button onClick={onSubmit} variant="contained" color="primary" disabled={saving}>
          {saving ? 'Tallennetaan...' : (isEditing ? 'Tallenna rata' : 'Lisää rata')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}